<template>
  <AppCarousel v-if="data.items && data.items.length" :slides="data.items" :unique-id="uid" />
</template>

<script>
import AppCarousel from '@/components/AppCarousel.vue';

export default {
  name: 'AppContentBlockImageCarousel',
  components: { AppCarousel },
  props: {
    uid: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
